import { useNavigate } from 'react-router-dom';
import { adminDashboardPaths } from '@/modules/admin-dashboard/routes.tsx';
import { SidebarMenuItem } from 'ui';
import {
  CertificateGrayIcon,
  CertificateWhiteIcon,
  DepartmentWhiteIcon,
  DepartmentsIcon,
  GridGrayIcon,
  GridWhiteIcon,
  UserManagementIcon,
  UserManagementInactiveIcon,
  UserManagementWhiteIcon,
} from 'ui/icons';

export const useAdminSidebarOptions = (): SidebarMenuItem[] => {
  const navigate = useNavigate();

  return [
    {
      label: 'Registers',
      icon: GridGrayIcon,
      activeIcon: GridWhiteIcon,
      disabledIcon: GridGrayIcon,
      pathname: adminDashboardPaths.static.registers,
      onClick: () => navigate(adminDashboardPaths.static.registers),
    },
    {
      label: 'Issuers',
      icon: UserManagementInactiveIcon,
      activeIcon: UserManagementWhiteIcon,
      disabledIcon: UserManagementIcon,
      pathname: adminDashboardPaths.static.issuers,
      onClick: () => navigate(adminDashboardPaths.static.issuers),
    },
    {
      label: 'Holders',
      icon: DepartmentsIcon,
      activeIcon: DepartmentWhiteIcon,
      disabledIcon: DepartmentsIcon,
      pathname: adminDashboardPaths.static.entities,
      onClick: () => navigate(adminDashboardPaths.static.entities),
    },
    {
      label: 'Validation',
      icon: CertificateGrayIcon,
      activeIcon: CertificateWhiteIcon,
      disabledIcon: CertificateGrayIcon,
      pathname: adminDashboardPaths.static.validation,
      onClick: () => navigate(adminDashboardPaths.static.validation),
    },
  ];
};
